import './App.css';
import 'leaflet/dist/leaflet.css';
import { useEffect, useState } from 'react';

import Footer from './components/footer';
import Hero from './components/hero';
import NavigationComponent from './components/navigationComponent';
import SEO from './components/SEO';
import TextSection from './components/textSection';
import { sectionEnum } from './sectionEnum';
import {
  PRACTICE_DESCRIPTION,
  PRACTICE_IMAGE,
  PRACTICE_KEYWORDS,
  PRACTICE_NAME,
  PRACTICE_STRUCTURED_DATA,
} from './seoConfig';
import { Analytics } from '@vercel/analytics/react';


const App = () => {
  const [pageLoaded, setPageLoaded] = useState(false);
  const pageTitle = `${PRACTICE_NAME} | Hamburg-Bergedorf`;

  useEffect(() => {
    const runAfterPageLoad = () => {
      setPageLoaded(true);
    };

    if (document.readyState === 'complete') {
      runAfterPageLoad();
    } else {
      window.addEventListener('load', runAfterPageLoad);
    }

    return () => {
      window.removeEventListener('load', runAfterPageLoad);
    };
  }, []);

  useEffect(() => {
    if (pageLoaded) {
      const fragment = window.location.hash;
      if (fragment) {
        const targetId = fragment.substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  }, [pageLoaded]);

  return (
    <>
      <Analytics />
      <SEO
        title={pageTitle}
        description={PRACTICE_DESCRIPTION}
        path="/"
        image={PRACTICE_IMAGE}
        keywords={PRACTICE_KEYWORDS}
        structuredData={PRACTICE_STRUCTURED_DATA}
        siteName={PRACTICE_NAME}
      />
      <NavigationComponent
        enums={[
          sectionEnum.WILLKOMMEN,
          sectionEnum.VERANSTALTUNGEN,
          sectionEnum.LEISTUNGEN,
          sectionEnum.TERMINE,
          sectionEnum.UEBER,
        ]}
      />
      <main>
        <Hero />
        <TextSection enum={sectionEnum.WILLKOMMEN} />
        <TextSection enum={sectionEnum.VERANSTALTUNGEN} />
        <TextSection enum={sectionEnum.LEISTUNGEN} />
        <TextSection enum={sectionEnum.TERMINE} />
        <TextSection enum={sectionEnum.UEBER} />
      </main>
      <Footer />
    </>
  );
};

export default App;
